import { render, staticRenderFns } from "./TheList.vue?vue&type=template&id=b503b7cc&scoped=true"
import script from "./TheList.vue?vue&type=script&lang=ts"
export * from "./TheList.vue?vue&type=script&lang=ts"
import style0 from "./TheList.vue?vue&type=style&index=0&id=b503b7cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b503b7cc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsModalShare: require('/usr/src/nuxt-app/components/elements/ModalShare.vue').default})
